import React from 'react';
import { mapDegreesCardinal } from '@surfline/web-common';
import { isNumber } from 'lodash';

interface BuoyDirectionProps {
  direction?: number | null;
}

const BuoyDirection: React.FC<BuoyDirectionProps> = ({ direction = null }) => {
  const directionString = isNumber(direction)
    ? `${mapDegreesCardinal(direction)} ${direction}º`
    : '- º';

  return <span className="sl-buoy-direction">{directionString}</span>;
};

export default BuoyDirection;
